import axios from 'axios'

export type AuthPaths = {
  loginPath: string
  logoutPath: string
}

export const logout =
  (paths: AuthPaths): (() => void) =>
  () => {
    const loginUrl = `${paths.loginPath}${paths.loginPath.includes('?') ? '&' : '?'}referrer=${encodeURIComponent(window.location.pathname + window.location.search)}`

    axios
      .post(paths.logoutPath)
      .then(() => {
        // @ts-expect-error
        window.setLocationHref(loginUrl)
      })
      .catch((error) => {
        const status = error.response?.status
        if (status === 401 || status === 403) {
          // @ts-expect-error
          window.setLocationHref(loginUrl)
        }
      })
  }
